import React, { useState ,useEffect}  from "react";
import { useNavigate } from "react-router";
import { pageRoutes } from "../routes/PageRoute";
import { NoAuthApiRequest,ApiRequest } from "./services/apiservice";
import { ApiEndpoints,ApiEndpointMethod } from "../utils/endpoints";
import { Formik } from "formik";
import { loginvalidationSchema } from "../utils/schema";
import ErrorMessage from "../components/ErrorMessage";
import Loader from "./shared/loader";
import { ToastContainer, toast } from "react-toastify";

const Login = () => {
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const [isEye, setIsEye] = useState(true);
    const [errorvalue, seterrorvalue] = useState('');
    const [rememberMe, setRememberMe] = useState(false);

    const [initialValue,setinitialValue] = useState({
        email: "",
        password: "",
      });

      useEffect(() => {
        localStorage.removeItem("user"); 
          //localStorage.removeItem("userremember"); 
debugger;
          const expiry = localStorage.getItem("user_expiry");
         if (expiry && Date.now() > Number(expiry)) {
              localStorage.removeItem("userremember");
              localStorage.removeItem("user_expiry");
         }
        const rememberedUser = localStorage.getItem("userremember");
           if (rememberedUser) {
           const user = JSON.parse(rememberedUser);
               setinitialValue({
                   email: user.Email || "",
                  password: user.Password || "",
           });
            if (user.RememberMe === true) {
                  setRememberMe(true);
                  handlelogin(user);
                }
                // Optionally, auto-login or pre-fill form
                ///navigate(pageRoutes?.dashboard);
          }
        }, []);

        const handleChangeTigger = (name, value) => {
          debugger;
        setinitialValue((prevState) => ({
         ...prevState,
         [name]: value,
       }));
 };

 const handlelogin = async(inivalue) => {

  //   setLoader(true);
              const formData = {
                Email: inivalue.Email,
                Password: inivalue.Password,
                RememberMe: rememberMe,
              };
              setLoader(true);
             
              const data = await NoAuthApiRequest(ApiEndpoints.Login.Authenticate,ApiEndpointMethod.Post,formData);
           
              if (data.success) {
                var _user = JSON.stringify(data.message);
                localStorage.setItem("user", _user);
                debugger;
                if (rememberMe) {
                 localStorage.setItem("userremember", JSON.stringify(formData));
                 

               } else {
                 sessionStorage.setItem("userremember", JSON.stringify(formData));
               }
                navigate(pageRoutes?.dashboard)
             
                // setTimeout(() => {
                //   setLoader(false);
                //   debugger;
                //   var _usr = JSON.parse(localStorage.getItem("user"));
                //   if(_usr.IsSuperAdmin==true){
                //     navigate(pageRoutes?.subscriptionList);
                //   }
                //   else{
                //   navigate(pageRoutes?.cost);
                //   }
                // }, 300);
              } else {
                  toast.error(data.message, {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "light",
                                    });
                setLoader(false);
                // toast.error(t(`Reponses.${data.message}`, { defaultValue: data.message }), {
                //   position: "top-right",
                //   autoClose: 3000,
                //   hideProgressBar: false,
                //   closeOnClick: true,
                //   pauseOnHover: true,
                //   draggable: true,
                //   progress: undefined,
                //   theme: "light",
                // });
              }
 }

        const handleLogin = async (values, validateForm, setTouched) => {
            const errors = await validateForm();
          
            if (Object.keys(errors).length === 0) {
            //   setLoader(true);
              const formData = {
                Email: values.email,
                Password: values.password,
                RememberMe: rememberMe,
              };
              setLoader(true);
             
              const data = await NoAuthApiRequest(ApiEndpoints.Login.Authenticate,ApiEndpointMethod.Post,formData);
           
              if (data.success) {
                var _user = JSON.stringify(data.message);
                localStorage.setItem("user", _user);
                if (rememberMe) {
                 localStorage.setItem("userremember", JSON.stringify(formData));
                 var val=(Date.now() + 7 * 24 * 60 * 60 * 1000).toString();
                 localStorage.setItem("user_expiry", val);
               } else {
                 sessionStorage.setItem("userremember", JSON.stringify(formData));
               }
                navigate(pageRoutes?.dashboard)
             
                // setTimeout(() => {
                //   setLoader(false);
                //   debugger;
                //   var _usr = JSON.parse(localStorage.getItem("user"));
                //   if(_usr.IsSuperAdmin==true){
                //     navigate(pageRoutes?.subscriptionList);
                //   }
                //   else{
                //   navigate(pageRoutes?.cost);
                //   }
                // }, 300);
              } else {
                  toast.error(data.message, {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "light",
                                    });
                setLoader(false);
                // toast.error(t(`Reponses.${data.message}`, { defaultValue: data.message }), {
                //   position: "top-right",
                //   autoClose: 3000,
                //   hideProgressBar: false,
                //   closeOnClick: true,
                //   pauseOnHover: true,
                //   draggable: true,
                //   progress: undefined,
                //   theme: "light",
                // });
              }
            } else {
              // Mark fields as touched to show error messages, but don't hide the current step
              setTouched(
                Object.keys(errors).reduce((acc, key) => {
                  acc[key] = true;
                  return acc;
                }, {})
              );
            }
          };

    return (
        <>
            <div className="login-wrapper">
                <div>
                    <div className="text-center mb-2">
                        <img src="assets/images/logo.png" style={{ height: '42px' }} />
                    </div>   
               <Formik
                  initialValues={initialValue}
                   enableReinitialize={true}
                  validationSchema={loginvalidationSchema()}
                  onSubmit={(values, validateForm, setTouched, actions) => {
                    handleLogin(values, validateForm, setTouched);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    validateForm,
                    setTouched,
                  }) => (                 
                    <div className="login-panel bg-white p-4 shadow-sm">
                        <h4 className="mb-5 text-center">Login</h4>
                        <div className="form-group">
                            <label className="mb-0">Email</label>
                            <input className="form-control" 
                            type="email"
                            id="email"
                             onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.email} />
                            <ErrorMessage
                                 errors={errors}
                                 touched={touched}
                                 fieldName="email"
                             />
                        </div>
                        <div className="form-group mb-1">
                            <label className="mb-0">Password</label>
                            <input className="form-control" type={isEye ? "password" : "text"}
                            id="password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.password} />
                           {/* <i
                            className={`fa-regular ct_eye_show ct_pointer_curser ${
                              isEye ? "fa-eye-slash" : "fa-eye"
                            }`}
                            onClick={() => setIsEye(!isEye)}
                          ></i> */}
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div className="form-check">
                                <input type="checkbox" 
                                className="form-check-input" id="remember" 
                                onChange={() => setRememberMe(!rememberMe)}/>
                                <label className="form-check-label" for="remember">Remember me</label>
                            </div>
                            <div>
                                <a className="text-muted">Forgot Password?</a>
                            </div>
                        </div>
                        <button className="btn btn-info w-100"  onClick={() =>
                          handleLogin(values, validateForm, setTouched)
                        }>Submit</button>
                    </div>
                 )}
                </Formik>
                </div>
            </div>
            {loader &&(
            <Loader/>
          )}
        </>
    );
};

export default Login;